import type { GenUiSearchWaitProfile } from './action.js';

interface TravelerRef {
  readonly id: string;
  readonly name: string;
}

/**
 * Whose profile a planner search reads, from the card's WHO and the id of the person
 * chatting. No WHO (old blocks, or a planner without one) means the person chatting
 * travels; without the requester id a single traveler is unknown, so it stays unset.
 */
export function searchWaitProfile(
  travelers: readonly TravelerRef[] | undefined,
  requesterId: string | undefined,
): GenUiSearchWaitProfile | undefined {
  if (!travelers || travelers.length === 0) return 'self';
  if (travelers.length > 1) return 'group';
  const [only] = travelers;
  if (!only || requesterId === undefined) return undefined;
  if (only.id === requesterId) return 'self';
  const first = only.name.trim().split(/\s+/)[0];
  return first ? { name: first } : undefined;
}

/** "São Paulo → Rio de Janeiro"; nothing when either end is missing. */
export function searchWaitRoute(origin: string | undefined, destination: string | undefined) {
  return origin && destination ? `${origin} → ${destination}` : undefined;
}
